export const API_ENDPOINT_COOKIE = "kenai-induction-endpoint";
export const INVITES_TOKEN_COOKIE = "kenai-induction-token";
export const HEADER_HEIGHT = 77; // px
export const LOCALE_COOKIE = "NEXT_LOCALE";
export const LOGGING_COOKIE = "kenai-induction-logging";
export const AGREEMENT_COOKIE = "kenai-induction-agreement";
export const DEV_MODE =
  process.env.NODE_ENV === "development" ||
  process.env.VERCEL_ENV === "preview";
